module.exports = __webpack_public_path__ + "media/images/history/tacova1-29a3d0e50bfdf03d7dae5bc914837247.jpg";